<template>
  <div>
    <section id="warning-signs" class="text-center siteSymptoms section">
      <div class="container">
        <h3>Bunion is a progressive condition that often gets worse if left untreated.</h3>
        <div class="row">
          <div class="mx-auto col-12 col-md-10">
            <p class="text-left text-sm-center">Without timely medical intervention, bunions increase in pain and get more deformed as time passes. In later stages, treatment options become limited and you may be left with surgical remedies. Consult our specialist if you or your loved ones are experiencing the following symptoms:</p>
          </div>
        </div>
        <div class="row list-symptoms d-flex justify-content-center">
          <div class="col-6 col-md-4 col-lg-3 col-xl-2" v-for="(symptoms, i) in symptoms" :key="i">
            <div class="symptom">
              <div><img :src="symptoms.image" class="inline-block img-fluid rounded-circle" :alt="symptoms.name"></div>
              <h4 v-html="symptoms.name"></h4>
            </div>
          </div>
        </div>
        <div id="pre-sport-screening" class="row">
          <div class="mx-auto col-12 col-xl-9 add-space">
            <p class="text-left text-sm-center">Bunion treatment can go a long way in preventing a permanent loss in mobility. Dr Sean Ng can help you overcome bunions with both surgical & non-surgical methods.</p>
          </div>
        </div>
        <a href="#enquire-now" class="site-btn">Enquire Now</a>
      </div>
    </section>
  </div>
</template>

<style scoped>
  .siteSymptoms {
    background: #f5f5f5;
  }
  .list-symptoms {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .symptom {
    margin-bottom: 20px;
  }
  .symptom img {
    margin-bottom: 15px;
    border: 4px solid #c9d2d5;
  }
  .symptom h4 {
    font-size: 16px;
    font-weight: 600;
    color: #0a1432;
    line-height: 24px;
  }
  .add-space img {
    margin: 30px 0;
  }
  @media (min-width: 992px) {
    .symptom img {
      border: 8px solid #c9d2d5;
    }
    .add-space {
      margin-top: 20px;
    }
  }
  @media (min-width: 1200px) {
    .symptom img {
      border: 4px solid #c9d2d5;
    }
  }
</style>

<script>
  export default {
    data () {
      return {
        symptoms: [
          {
            image: '/images/img-symptoms-01.jpg',
            name: 'Limited Mobility',
          },
          {
            image: '/images/img-symptoms-02.jpg',
            name: 'Deformed Neighbouring Toes',
          },
          {
            image: '/images/img-symptoms-03.jpg',
            name: 'Instability in Walking',
          },
          {
            image: '/images/img-symptoms-04.jpg',
            name: 'Problems in the mid/hind foot',
          }
        ]
      }
    }
  }
</script>